import { useMemo } from "react";
import {
  AccountSignInResponseDto,
  ExporterUserDto,
  ExporterUserType,
} from "../store/apis/auth/interface";

export interface NormalizedUser {
  accountId: number | null;
  email: string | null;
  name: string | null;
  language: string | null | undefined;
  companyName: string | null;
  role: ExporterUserType | null;
  originalUser: ExporterUserDto | AccountSignInResponseDto;
  isExporterUser: boolean;
  isAccountUser: boolean;
  isActivated: boolean;
}

export function useNormalizedUser(
  user: ExporterUserDto | AccountSignInResponseDto | null,
): NormalizedUser | null {
  return useMemo(() => {
    if (!user) return null;

    if ("account" in user && "accountDto" in user) {
      console.error(
        "[useNormalizedUser] Invalid user object: contains both types",
        user,
      );
      return null;
    }

    const isExporterUser =
      "account" in user &&
      user.account !== null &&
      user.account !== undefined &&
      "exporterUserType" in user;

    const isAccountUser =
      "accountDto" in user &&
      user.accountDto !== null &&
      user.accountDto !== undefined &&
      !("exporterUserType" in user);

    if (!isExporterUser && !isAccountUser) {
      console.error("[useNormalizedUser] Invalid user object:", user);
      return null;
    }

    return {
      accountId: isExporterUser
        ? user.account?.id
        : isAccountUser
          ? user.accountDto?.id
          : null,

      email: isExporterUser
        ? user.email
        : isAccountUser
          ? user.accountDto?.email
          : null,

      name: isExporterUser
        ? user.name
        : isAccountUser
          ? user.accountDto?.name
          : null,

      language: isExporterUser
        ? user.account?.language
        : isAccountUser
          ? user.accountDto?.language
          : null,

      companyName: isExporterUser ? user.exporter?.companyName : null,

      role: isExporterUser ? user.exporterUserType : null,

      isActivated: isExporterUser
        ? user.account?.isActivated ?? false
        : isAccountUser
          ? user.accountDto?.isActivated ?? false
          : false,

      originalUser: user,
      isExporterUser,
      isAccountUser,
    };
  }, [user]);
}
